import { render, staticRenderFns } from "./releaseRecord.vue?vue&type=template&id=4ad62022&scoped=true"
import script from "./releaseRecord.vue?vue&type=script&lang=js"
export * from "./releaseRecord.vue?vue&type=script&lang=js"
import style0 from "./releaseRecord.vue?vue&type=style&index=0&id=4ad62022&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad62022",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ad62022')) {
      api.createRecord('4ad62022', component.options)
    } else {
      api.reload('4ad62022', component.options)
    }
    module.hot.accept("./releaseRecord.vue?vue&type=template&id=4ad62022&scoped=true", function () {
      api.rerender('4ad62022', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/commodityManagement/dishesManagement/releaseRecord.vue"
export default component.exports